<template>

    <div :class="['dimmer' , loading || form.loading ?  'active' : '']">
        <div class="loader"></div>
        <div class="dimmer-content">
            <form @submit.prevent="create" method="post">
                <div v-if="message" class="bg-primary text-center text-white px-3 py-3">
                    {{ message }}
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label>Old Password</label>
                            <input type="password" v-model="form.old_password"
                                   :class="[ 'form-control' , form.errors.get('old_password') ? 'is-invalid' : '' ]"
                                   placeholder="Enter password">
                            <div v-text="form.errors.get('old_password')" class="invalid-feedback"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>New Password</label>
                            <input type="password" v-model="form.password"
                                   :class="[ 'form-control' , form.errors.get('password') ? 'is-invalid' : '' ]"
                                   placeholder="Enter password">
                            <div v-text="form.errors.get('password')" class="invalid-feedback"/>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>Password Repeat</label>
                            <input type="password" v-model="form.password_confirmation"
                                   :class="[ 'form-control' , form.errors.get('password_confirmation') ? 'is-invalid' : '' ]"
                                   placeholder="Repeat password">
                            <div v-text="form.errors.get('password_confirmation')"
                                 class="invalid-feedback"/>
                        </div>
                    </div>
                </div>
                <button @click.prevent="create"
                        :class="['btn btn-primary btn-block mt-2' ,  form.loading ? 'btn-loading' : '']"
                        type="submit">Save Changes
                </button>
            </form>
        </div>
    </div>

</template>

<script>
import Form from "../../../core/forms/form";

export default {
    name: "Index",
    data() {
        return {
            loading: false,
            message: null,
            form: new Form({
                password: '',
                old_password: '',
                password_confirmation: '',
            }, {}),
        };
    },

    mounted() {
    },

    methods: {
        create() {
            window.Swal.fire({
                title: 'Are you sure ?',
                text: `You want to update your password`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#22568C',
                cancelButtonColor: '#d33',
                confirmButtonText: `Yes, Update!`
            }).then((result) => {
                if (result.value) {
                    this.form.submit('/admin/password').then((response) => {
                        this.message = "Your password was successfully updated";
                        this.form.reset();
                    }).catch((error) => {
                    });
                }
            });
        }
    }
}
</script>

<style scoped>

</style>
